import BookShipmentArrangingPickupLoading from "../CustomComponents/BookShipmentArrangingPickupLoading";
import BookShipmentBookingLoading from "../CustomComponents/BookShipmentBookingLoading";
import BookShipmentFinalizingBookingLoading from "../CustomComponents/BookShipmentFinalizingBookingLoading";
import BookShipmentGeneratingDocumentsLoading from "../CustomComponents/BookShipmentGeneratingDocumentsLoading";

export interface BookingStep {
  title: string;
  description: string;
  percentageRange: number[];
  icon: React.ReactNode;
}

export const BOOKING_STEPS: BookingStep[] = [
  {
    title: "Booking Shipment",
    description: "Confirming shipment details with carrier",
    percentageRange: [15, 18, 20, 22, 25],
    icon: <BookShipmentBookingLoading />,
  },
  {
    title: "Generating Documents",
    description: "Creating shipping labels, BOL, and required documentation",
    percentageRange: [35, 38, 40, 42, 45],
    icon: <BookShipmentGeneratingDocumentsLoading />,
  },
  {
    title: "Arranging Pickup",
    description: "Scheduling pickup with carrier and notifying pickup location",
    percentageRange: [60, 63, 65, 68, 70],
    icon: <BookShipmentArrangingPickupLoading />,
  },
  {
    title: "Finalizing Booking",
    description: "Completing booking setup and preparing tracking information",
    percentageRange: [85, 90, 92, 95, 98],
    icon: <BookShipmentFinalizingBookingLoading />,
  },
];

// Random timeouts for each step (in milliseconds)
export const STEP_TIMEOUTS = [4000, 6000, 5000, 4500, 3000];
